/* eslint camelcase:0, @typescript-eslint/camelcase:0 */
import invariant from 'invariant';

import defaultTrackingParams from './defaultTrackingParams';
import { getTMS, deriveFunnelName } from './utils';

import { TrackView } from '../types';

function trackView(params: Partial<TrackView> = {}): void {
  try {
    const track = getTMS('View');

    // if (!track) return;

    const { site, page, funnel, event } = params;

    const siteParams = Object.assign({}, defaultTrackingParams.site, site);
    const pageParams = Object.assign({}, defaultTrackingParams.page, page);

    let trackParams = {
      // tells telium library version
      comp_lib_version: '16',
      site_domain: siteParams.domain,
      site_region: siteParams.region,
      site_subregion: siteParams.subregion,
      site_country: siteParams.country,
      site_entity: siteParams.entity,
      site_brand: siteParams.brand,

      page_url: pageParams.url,
      page_name: `${pageParams.system}:${pageParams.category}:${pageParams.subcategory}:${pageParams.name}`,
      page_language: pageParams.language,
      page_type: pageParams.type,
      page_channel: pageParams.type,
      page_category: pageParams.category,
      page_subcategory: pageParams.subcategory,
      page_business_line: pageParams.businessLine,
      page_customer_group: pageParams.customerGroup,
    };

    if (funnel) {
      trackParams = Object.assign({}, trackParams, {
        funnel_name: funnel.name,
        funnel_step: funnel.step,
        funnel_step_name: deriveFunnelName(funnel),
      });
    }

    if (event) {
      trackParams = Object.assign({}, trackParams, {
        event_action: event.action,
        event_category: event.category,
        event_content: event.content,
      });
    }

    track(trackParams);
  } catch (error) {
    invariant(error, error);
  }
}

export default trackView;
